import ButtonCta from '../ButtonCta';
import Box from '../UI/Box';
import ButtonBase from '../UI/ButtonBase';
import { IButtonsTableBottomProps } from './types';

const ButtonsTableBottom: React.FC<IButtonsTableBottomProps> = ({
  isDisabled,
  isLoading,
  handleClickButtonCancel,
  handleClickButtonCta,
}) => {
  return (
    <Box width={'100%'} justifyContent="center" alignItems="center" gap={20}>
      <ButtonBase
        onClick={handleClickButtonCancel}
        padding={'15px 30px'}
        border={'2px solid #005F47'}
        borderRadius={12}
        color="#005F47"
        fontWeight={700}
        fontSize={16}
        width={'100%'}
        maxWidth={220}
        justifyContent="center"
      >
        Cancelar
      </ButtonBase>
      <ButtonCta
        title="Salvar"
        handleClick={handleClickButtonCta}
        padding={'15px 30px'}
        width={'100%'}
        maxWidth={250}
        disabled={isDisabled || isLoading}
        isLoading={isLoading}
      />
    </Box>
  );
};

export default ButtonsTableBottom;
